import React from 'react';
import { Github, Linkedin, Mail, Coffee } from 'lucide-react';
import { socialLinks } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-900 py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
      
          <div className="flex items-center gap-2 text-gray-400 text-sm">
            <span>Construído com código e café</span>
            <Coffee size={16} className="text-orange-400" />
            <span>por Daniel Lima</span>
          </div>

       
          <div className="flex items-center gap-6">
            <a
              href={socialLinks.github}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors duration-200"
              aria-label="GitHub"
            >
              <Github size={20} />
            </a>
            <a
              href={socialLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-blue-400 transition-colors duration-200"
              aria-label="LinkedIn"
            >
              <Linkedin size={20} />
            </a>
            <a
              href={socialLinks.email}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-purple-400 transition-colors duration-200"
              aria-label="E-mail"
            >
              <Mail size={20} />
            </a>
          </div>

         
          <div className="text-gray-500 text-sm">
            © {currentYear} Daniel Lima. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;